import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { environment } from 'environments/environment';
import { map } from 'rxjs';

export const apiResponseInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes(environment.api) && req.method !== 'OPTIONS') {
    return next(req).pipe(
      map((res: any) => {
        if (res.body?.data) {
          return new HttpResponse({
            body: res.body.data,
            status: res.status,
            statusText: res.statusText,
          });
        }
        return res;
      })
    );
  }
  return next(req);
};
